module.exports = __webpack_public_path__ + "img/page-timer.2a68c043.png";